/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import InputGrid from "screens/leads/components/InputGrid";
import { RiDeleteBin6Line, RiMessage2Fill } from "react-icons/ri";
import { MdSend, MdSwapHoriz } from "react-icons/md";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Skeleton,
  Tooltip,
} from "@mui/material";
import { BsPaperclip } from "react-icons/bs";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useHistoricoGrupos } from "services/api/AppWeb_Oportunidade/get-historico-grupos";
import {
  HistoricoMensagem,
  useHistoricoMensagem,
} from "services/api/AppWeb_Oportunidade/post-historico-chat";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { obterNomeEtapaExibicao } from "utils/obterNomeEtapaExibicao";
import useInfiniteScroll from "hooks/useInfiniteScroll";
import ModalCommon from "components/ModalCommon";
import ModalComprovanteAto from "../propostaCard/components/modalComprovanteAto";
import * as S from "./styles";
import {
  bg_,
  defaultIcon,
  highlightTitle,
  iconMap,
  tooltipStyle,
  HistoricoType,
  readAttachmentFile,
} from "./utils";

export const HistoricoCard = ({
  data,
  historico,
  search,
  setSearch,
  onAplicarBusca,
  refetchHistorico,
  refetchDetalheOportunidade,
  isFetchingHistorico,
  isFetchingNextPage,
  fetchNextPage,
  hasNextPage,
  isLoading,
}: {
  data: any;
  historico: any[];
  refetchHistorico: () => Promise<any>;
  refetchDetalheOportunidade: () => void;
  search: { palavraChave: string; searching: boolean };
  setSearch: (value: { palavraChave: string; searching: boolean }) => void;
  onAplicarBusca: (value: string) => void;
  isFetchingHistorico: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isLoading: boolean;
}) => {
  const { usuarioVivaz } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [message, setMessage] = useState("");
  const [expanded, setExpanded] = useState<string[]>([]);
  const [is, setIs] = useState({
    sending: false,
  });
  const url: any = useParams();

  const [opt, setOpt] = useState<{
    selected: { name: string; id: number };
    open: boolean;
  }>({
    selected: { name: "", id: -1 },
    open: false,
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [mentionQuery, setMentionQuery] = useState<string | null>(null);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const messageFieldRef = useRef<HTMLInputElement>(null);

  const [openTrocarComprovante, setOpenTrocarComprovante] = useState(false);

  const [attachment, setAttachment] = useState<{
    file: File | undefined | null;
    hover: boolean;
  }>({
    file: null,
    hover: false,
  });
  const attachmentRef = useRef<HTMLInputElement>(null);

  const { data: grupos } = useHistoricoGrupos();

  // O histórico chega do mais recente para o mais antigo, então o primeiro
  // registro de comprovante do ato é o que está valendo. Só nele oferecemos a
  // troca, para não dar a impressão de que um envio antigo pode ser alterado.
  const idUltimoComprovanteAto = historico?.find(
    (item: any) =>
      item?.codigoTipoHistorico === HistoricoType.ComprovantePagamentoAto
  )?.id;

  const renderIcon = (type: HistoricoType) => {
    const { color, IconComponent } = iconMap[type] || defaultIcon;
    return <IconComponent color={color} size={22} />;
  };

  const handleOpt = useCallback(
    ({
      e,
      val,
    }: {
      e?: React.MouseEvent<HTMLElement> | null;
      val?: { name: string; id: number };
    }) => {
      if (e) {
        setAnchorEl(e.currentTarget);
        setOpt((prev) => ({ ...prev, open: true }));
      }

      if (!val) return;
      if (opt.selected.id !== -1) {
        // Substitui a menção antiga pela nova
        const oldMention = `@${opt.selected.name}`;
        const newMention = `@${val.name}`;

        // Se por algum motivo a menção anterior não estiver no texto,
        // apenas insira a nova menção no início.
        const newMessage = message.includes(oldMention)
          ? message.replace(oldMention, newMention)
          : `${newMention} ${message}`;

        setMessage(newMessage);
      } else {
        // Não havia menção antes, insere normalmente
        setMessage((prev) => `@${val.name} ${prev}`);
      }

      setOpt((prev) => ({
        ...prev,
        selected: { name: val.name, id: val.id },
        open: false,
      }));
      setAnchorEl(null);
    },
    [setAnchorEl, setOpt, setMessage, message, opt.selected]
  );

  const gruposFiltrados = grupos?.filter((item: { nomeGrupo: string }) =>
    mentionQuery
      ? item.nomeGrupo.toLowerCase().includes(mentionQuery.toLowerCase())
      : true
  );

  const handleMessageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const cursor = e.target.selectionStart ?? value.length;
    const upToCursor = value.slice(0, cursor);
    const match = upToCursor.match(/@([^@\s]*)$/);

    setMessage(value);
    setHighlightedIndex(0);

    if (match) {
      setMentionQuery(match[1]);
      setAnchorEl(messageFieldRef.current);
      setOpt((prev) => ({ ...prev, open: true }));
    } else {
      setMentionQuery(null);
      setOpt((prev) => ({ ...prev, open: false }));
    }
  };

  const handleSelectMention = (val: { name: string; id: number }) => {
    setMessage((prev) => prev.replace(/@([^@\s]*)$/, `@${val.name} `));
    setOpt((prev) => ({
      ...prev,
      selected: { name: val.name, id: val.id },
      open: false,
    }));
    setMentionQuery(null);
    setAnchorEl(null);
  };

  const handleMessageKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (mentionQuery === null || !gruposFiltrados?.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => (prev + 1) % gruposFiltrados.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(
        (prev) => (prev - 1 + gruposFiltrados.length) % gruposFiltrados.length
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      const item = gruposFiltrados[highlightedIndex];
      if (item) {
        handleSelectMention({ name: item.nomeGrupo, id: item.id });
      }
    } else if (e.key === "Escape") {
      setMentionQuery(null);
      setOpt((prev) => ({ ...prev, open: false }));
      setAnchorEl(null);
    }
  };

  const handleSearch = useCallback(() => {
    setExpanded([]);
    setSearch({ ...search, searching: true });
    // Aplicar o termo troca a queryKey e o React Query reinicia a
    // paginação da página 1 — não é necessário refetch manual.
    onAplicarBusca(search.palavraChave.trim());
  }, [search, setSearch, onAplicarBusca]);

  const handlePostMessage = async () => {
    setIs((prev) => ({ ...prev, sending: true }));

    try {
      const anexo = attachment.file
        ? [await readAttachmentFile(attachment.file)]
        : null;

      const params: HistoricoMensagem = {
        idOportunidade: data?.idOportunidade,
        numeroCotacao: data?.numeroCotacao,
        numeroFicha: data?.numeroFicha,
        idLeadCorretor: url.idLeadCorretor,
        idLead: data?.idLead365,
        mensagem: message,
        idGrupoDestinatario:
          opt.selected.id === -1 ? undefined : opt.selected.id,
        anexo,
      };

      const res = await useHistoricoMensagem(params);
      if (res.success) {
        setMessage("");
        setAttachment({ file: null, hover: false });
        setOpt((prev) => ({ ...prev, selected: { name: "", id: -1 } }));
      } else {
        throw new Error("Erro ao enviar mensagem");
      }
    } catch (err) {
      console.error(err);
      toast.error("Erro ao enviar mensagem, por favor tente novamente");
    } finally {
      refetchHistorico().then(() => {
        setIs((prev) => ({ ...prev, sending: false }));
      });
    }
  };

  const handleAccordion = useCallback((id: string) => {
    setExpanded((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  }, []);

  const { sentinelRef, scrollRootRef, handleScroll } = useInfiniteScroll({
    hasNextPage,
    // `isFetchingHistorico` cobre também o refetch da página 1, evitando
    // disparar a próxima página enquanto a lista está sendo reconstruída.
    isFetching: isFetchingHistorico || isFetchingNextPage,
    fetchNextPage,
    enabled: !isLoading,
  });

  useEffect(() => {
    if (opt.selected.id !== -1) {
      const mentionString = `@${opt.selected.name}`;
      // Se a mention não estiver mais na mensagem, resetar o opt
      if (!message.includes(mentionString)) {
        setOpt((prev) => ({
          ...prev,
          selected: { name: "", id: -1 },
        }));
      }
    }
  }, [message, opt.selected]);

  // return (
  //   <S.Container>
  //     <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
  //       <S.TitleHeader>HISTÓRICO</S.TitleHeader>
  //     </div>
  //     <S.RowLine />
  //     <S.TextHeader>Em desenvolvimento</S.TextHeader>
  //   </S.Container>
  // );
  return (
    <S.Container>
      {isLoading ? (
        <Skeleton variant="rounded" width="100%" height="100%" />
      ) : (
        <>
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <S.TitleHeader>HISTÓRICO</S.TitleHeader>
          </div>
          <S.RowLine />
          <S.PesquisarHeader>
            <InputGrid
              handleBtnSearch={handleSearch}
              value={search.palavraChave}
              onChange={(e) => {
                setSearch({ ...search, palavraChave: e.target.value });
              }}
              variant="outlined"
              autoComplete="off"
            />
            <div className="type">
              <S.PrimaryButton
                type="button"
                onClick={(e) => {
                  handleOpt({ e });
                }}
              >
                <div className="icon-container">
                  <RiMessage2Fill color="#2D5BFF" size={22} />
                </div>
              </S.PrimaryButton>
              {/* options */}
              <Menu
                open={opt.open}
                onClose={() => {
                  setOpt((prev) => ({ ...prev, open: false }));
                  setAnchorEl(null);
                  setMentionQuery(null);
                }}
                anchorEl={anchorEl}
                autoFocus={false}
                disableAutoFocus
                disableEnforceFocus
              >
                {mentionQuery !== null && gruposFiltrados?.length === 0 && (
                  <MenuItem disabled>Nenhuma área encontrada</MenuItem>
                )}
                {(mentionQuery !== null ? gruposFiltrados : grupos)?.map(
                  (item: { id: number; nomeGrupo: string }, index: number) => (
                    <MenuItem
                      key={item?.id}
                      selected={
                        mentionQuery !== null && index === highlightedIndex
                      }
                      onClick={() =>
                        mentionQuery !== null
                          ? handleSelectMention({
                              name: item?.nomeGrupo,
                              id: item?.id,
                            })
                          : handleOpt({
                              val: { name: item?.nomeGrupo, id: item?.id },
                            })
                      }
                    >
                      {item?.nomeGrupo}
                    </MenuItem>
                  )
                )}
              </Menu>

              <S.MessageField
                inputRef={messageFieldRef}
                placeholder="Marque a área desejada com @"
                value={message}
                onChange={handleMessageChange}
                onKeyDown={handleMessageKeyDown}
                fullWidth
                disabled={is.sending}
                size="small"
                autoComplete="off"
                sx={{
                  "& fieldset": { border: "none" },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      <Tooltip
                        arrow
                        placement="top"
                        title={
                          attachment?.file && !is.sending
                            ? `Remover anexo: ${attachment?.file?.name}`
                            : ""
                        }
                        componentsProps={tooltipStyle.error}
                      >
                        <IconButton
                          onClick={() => {
                            if (attachment?.file) {
                              setAttachment({ file: null, hover: false });
                              if (attachmentRef.current)
                                attachmentRef.current.value = "";
                            } else {
                              attachmentRef.current?.click();
                            }
                          }}
                          style={{
                            height: 36,
                          }}
                          onMouseEnter={() => {
                            !is.sending &&
                              setAttachment((prev) => ({
                                ...prev,
                                hover: true,
                              }));
                          }}
                          onMouseLeave={() => {
                            !is.sending &&
                              setAttachment((prev) => ({
                                ...prev,
                                hover: false,
                              }));
                          }}
                          disabled={is.sending}
                        >
                          {attachment?.file ? (
                            attachment?.hover ? (
                              <RiDeleteBin6Line size={18} color="red" />
                            ) : (
                              <BsPaperclip size={18} color="#2D5BFF" />
                            )
                          ) : (
                            <BsPaperclip size={18} color="#A3A3A6" />
                          )}
                        </IconButton>
                      </Tooltip>
                      <input
                        type="file"
                        ref={attachmentRef}
                        onChange={(e) => {
                          setAttachment({
                            file: e?.target?.files?.[0],
                            hover: false,
                          });
                        }}
                        style={{ display: "none" }}
                        accept="*/*"
                      />
                    </InputAdornment>
                  ),
                  style: { fontSize: 14 },
                }}
              />

              <S.PrimaryButton
                type="button"
                onClick={() => {
                  !is.sending && handlePostMessage();
                }}
                disabled={is.sending}
              >
                <div className="icon-container">
                  {is.sending ? (
                    <CircularProgress style={{ color: "#2D5BFF" }} size={18} />
                  ) : (
                    <MdSend color="#2D5BFF" size={22} />
                  )}
                </div>
              </S.PrimaryButton>
            </div>
          </S.PesquisarHeader>

          <S.Content ref={scrollRootRef} onScroll={handleScroll}>
            {historico?.map((item: any) => (
              <Fragment key={item?.id}>
                <Accordion
                  disableGutters
                  elevation={0}
                  square={false}
                  expanded={expanded.includes(item?.id)}
                  onChange={() => {
                    handleAccordion(item?.id);
                  }}
                  sx={{
                    "&:before": {
                      display: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    sx={{
                      padding: 0,
                      "& .MuiAccordionSummary-root": { width: "100%" },
                    }}
                  >
                    <S.SummaryContent
                      enlarge={
                        item?.codigoTipoHistorico === HistoricoType.Chat &&
                        expanded.includes(item?.id)
                      }
                    >
                      <div style={{ width: 36 }}>
                        <S.IconContainer bg={bg_(item?.codigoTipoHistorico)}>
                          {renderIcon(item?.codigoTipoHistorico)}
                        </S.IconContainer>
                      </div>
                      <div className="text">
                        {highlightTitle(
                          item?.codigoTipoHistorico === HistoricoType.Chat
                            ? item?.mensagem ?? ""
                            : obterNomeEtapaExibicao(item?.titulo, usuarioVivaz)
                        )}
                      </div>
                      <div className="expand">
                        {expanded.includes(item?.id) ? (
                          <FaChevronUp className="icon" size={12} />
                        ) : (
                          <FaChevronDown className="icon" size={12} />
                        )}
                        {item?.dataHora && (
                          <p className="dataHora">{item?.dataHora}</p>
                        )}
                        <p>{item?.tempo}</p>
                      </div>
                    </S.SummaryContent>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      padding:
                        item.anexos?.length > 0 ||
                        item?.justificativa ||
                        item?.resultado ||
                        item?.bodyHtml ||
                        item?.id === idUltimoComprovanteAto
                          ? "8px 16px 16px 0px"
                          : 0,
                    }}
                  >
                    <S.DetailsContent>
                      {item?.anexos?.length > 0 && (
                        <p>
                          <strong>Anexos: </strong>
                          {item.anexos.map((anexo: string, index: number) => (
                            <React.Fragment key={index}>
                              {index > 0 && ", "}
                              <a href={anexo} target="_blank" rel="noreferrer">
                                Download Anexo {index + 1}
                              </a>
                            </React.Fragment>
                          ))}
                        </p>
                      )}

                      {item?.bodyHtml ? (
                        <div
                          style={{ width: "100%" }}
                          dangerouslySetInnerHTML={{ __html: item?.bodyHtml }}
                        />
                      ) : null}

                      {item?.resultado && (
                        <p>
                          <strong>{"Resultado: "}</strong>
                          {item?.resultado}
                        </p>
                      )}

                      {item?.justificativa && (
                        <p>
                          <strong>{"Justificativa: "}</strong>
                          {item?.justificativa}
                        </p>
                      )}

                      {item?.id === idUltimoComprovanteAto && (
                        <S.TrocarArquivoButton
                          type="button"
                          onClick={() => setOpenTrocarComprovante(true)}
                        >
                          <MdSwapHoriz size={16} />
                          Trocar arquivo
                        </S.TrocarArquivoButton>
                      )}
                    </S.DetailsContent>
                  </AccordionDetails>
                </Accordion>
                <S.Divider />
              </Fragment>
            ))}

            {isFetchingHistorico && (
              <S.LoadingContainer>
                <CircularProgress style={{ color: "#2D5BFF" }} size={18} />
              </S.LoadingContainer>
            )}

            {!isFetchingHistorico && historico?.length === 0 && (
              <S.TextHeader>
                {search.searching
                  ? "Nenhum registro encontrado para a busca"
                  : "Nenhum histórico disponível"}
              </S.TextHeader>
            )}

            {/* Sentinela do scroll infinito: precisa ficar DENTRO do
                container que rola, no fim da lista. */}
            <div ref={sentinelRef} style={{ height: 1, flexShrink: 0 }} />
          </S.Content>
        </>
      )}

      <ModalCommon
        open={openTrocarComprovante}
        setOpenModal={setOpenTrocarComprovante}
        onClose={() => setOpenTrocarComprovante(false)}
      >
        <ModalComprovanteAto
          isReplace
          onClose={() => setOpenTrocarComprovante(false)}
          dataDetalheOportunidade={data}
          refetchDetalheOportunidade={refetchDetalheOportunidade}
          refetchHistorico={refetchHistorico}
        />
      </ModalCommon>
    </S.Container>
  );
};
